var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("m-chat", {
        ref: "chat",
        attrs: {
          entity: _vm.entity,
          "entity-id": _vm.entityId,
          "can-edit": _vm.canEdit,
        },
        on: { close: _vm.updateCount },
      }),
      _vm.visible
        ? _c("c-button", {
            attrs: {
              size: "small",
              icon: "comment",
              label: _vm.commentsLabel,
              tooltip: {
                text: "Комментарий",
                activeText: "Комментарий",
              },
            },
            on: { click: _vm.openChat },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }